module.exports = __webpack_public_path__ + "static/img/a9.e599579.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/certificate/attestation/a9.png
// module id = x9YI
// module chunks = 0